module.exports = __webpack_public_path__ + "img/15.be0e023b.jpg";